import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { TeamsService } from '../../services/teams.service';
import * as TeamsActions from '../actions/teams.actions';
import { MessageService } from 'primeng/api';
@Injectable({ providedIn: 'root' })
export class TeamsEffects {
    private actions$ = inject(Actions);
    private teamsService = inject(TeamsService);
    private messageService = inject(MessageService);
    loadTeams$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TeamsActions.loadTeams),
            switchMap(() =>
                this.teamsService.getTeams().pipe(
                    map(teams => TeamsActions.loadTeamsSuccess({ teams })),
                    catchError(error => of(TeamsActions.loadTeamsFailure({ error })))
                )
            )
        )
    );

    loadTeamsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TeamsActions.loadTeamsSuccess),
                tap(({ teams }) => {
                })
            ),
        { dispatch: false }
    );

    loadTeamsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TeamsActions.loadTeamsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );

    createTeam$ = createEffect(() =>
        this.actions$.pipe(
            ofType(TeamsActions.createTeam),
            switchMap(({ team }) =>
                this.teamsService.createTeam(team).pipe(
                    map(() => TeamsActions.createTeamSuccess()),
                    catchError(error => of(TeamsActions.createTeamFailure({ error })))
                )
            )
        )
    );

    createTeamSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TeamsActions.createTeamSuccess),
                tap(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Equipe créée avec succès',
                        life: 3000
                    });
                })
            ),
        { dispatch: false }
    );

    createTeamFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(TeamsActions.createTeamFailure),
                tap(({ error }) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Erreur lors de la création de l\'équipe',
                        life: 3000
                    });
                })
            ),
        { dispatch: false }
    );
}
